/** Pixel sizes backed by the --lyra-icon-size-* tokens (xs / sm / md / lg). */
export type EspIconSize = 12 | 16 | 20 | 24;

/** `#lyra-<name>` fragment of a symbol in the bundled Lyra sprite. */
export function lyraIconHref(name: string): string {
  return `#lyra-${name}`;
}

/**
 * Markup for a decorative Lyra icon, for places that take an HTML string
 * instead of a component (AG Grid `icons` grid option, cell renderers).
 * Same DOM as <esp-icon>'s inner <svg>.
 */
export function espIconHtml(name: string, extraClass = ""): string {
  const cls = extraClass ? `esp-icon ${extraClass}` : "esp-icon";
  return `<svg class="${cls}" aria-hidden="true" focusable="false"><use href="${lyraIconHref(name)}"></use></svg>`;
}

/** AG Grid `icons` grid option: Lyra sort indicators. */
export const ESP_GRID_SORT_ICONS = {
  sortAscending: espIconHtml("arrow-up-narrow-wide"),
  sortDescending: espIconHtml("arrow-down-wide-narrow")
};

/** AG Grid `icons` grid option: Lyra sort indicators + read-only/disabled checkbox glyphs. */
export const ESP_GRID_ICONS = {
  checkboxDisabled: espIconHtml("square"),
  checkboxCheckedReadOnly: espIconHtml("square-check"),
  ...ESP_GRID_SORT_ICONS
};

/** Dialog message types (DialogOptions.msgType) and their Lyra status icon. */
const STATUS_ICONS: Record<string, string> = {
  warn: "warning",
  error: "circle-alert",
  info: "info"
};

/** Lyra icon for a dialog message type ("warn" | "error" | "info"), or null. */
export function statusIconName(msgType: string | null | undefined): string | null {
  return (msgType && STATUS_ICONS[msgType]) || null;
}
